// import { parseEnv } from 'znv/compat';
import { Effect, Result, Schema } from 'effect';

// import type * as _ from '../../../../node_modules/znv/dist/util/type-helpers';

/** @internal nextjs */
export const envVars = {
	NEXT_PUBLIC_CLERK_JWT_KEY: process.env.NEXT_PUBLIC_CLERK_JWT_KEY,
	NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
	NEXT_PUBLIC_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL,
	NEXT_PUBLIC_CLERK_SIGN_IN_FORCE_REDIRECT_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_FORCE_REDIRECT_URL,
	// NEXT_PUBLIC_CLERK_SIGN_IN_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
	NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL,
	NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL,
	// NEXT_PUBLIC_CLERK_SIGN_UP_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL,
	NEXT_PUBLIC_DEFAULT_COLOR_SCHEME: process.env.NEXT_PUBLIC_DEFAULT_COLOR_SCHEME,
	NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
	NEXT_PUBLIC_GOOGLE_ANALYTICS_LOGIN_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_LOGIN_ID,
	NEXT_PUBLIC_JWT_AUDIENCE_CLOUDPRINT: process.env.NEXT_PUBLIC_JWT_AUDIENCE_CLOUDPRINT,
	NEXT_PUBLIC_ORG_ID_FRACHTER: process.env.NEXT_PUBLIC_ORG_ID_FRACHTER,
	NEXT_PUBLIC_ORIGIN_RUN: process.env.NEXT_PUBLIC_ORIGIN_RUN,
	NEXT_PUBLIC_ORIGIN_WWW: process.env.NEXT_PUBLIC_ORIGIN_WWW,
};

/** @internal nextjs */
export const DEFAULTS = {
	NEXT_PUBLIC_CLERK_JWT_KEY: 'FIX_NEXTJS',
	NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: 'FIX_NEXTJS',
	NEXT_PUBLIC_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL: 'FIX_NEXTJS',
	NEXT_PUBLIC_CLERK_SIGN_IN_FORCE_REDIRECT_URL: 'FIX_NEXTJS',
	// NEXT_PUBLIC_CLERK_SIGN_IN_URL: 'FIX_NEXTJS',
	NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL: 'FIX_NEXTJS',
	NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL: 'FIX_NEXTJS',
	NEXT_PUBLIC_ORIGIN_RUN: 'https://run.frachter.app',
	// NEXT_PUBLIC_CLERK_SIGN_UP_URL: 'FIX_NEXTJS',
	NEXT_PUBLIC_ORIGIN_WWW: 'https://www.frachter.app',
};

/** @internal nextjs */
export const envSchema = Schema.Struct({
	NEXT_PUBLIC_CLERK_JWT_KEY: Schema.String,
	NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: Schema.String,
	NEXT_PUBLIC_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL: Schema.String,
	NEXT_PUBLIC_CLERK_SIGN_IN_FORCE_REDIRECT_URL: Schema.String,
	// NEXT_PUBLIC_CLERK_SIGN_IN_URL: Schema.String,
	NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL: Schema.String,
	NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL: Schema.String,
	// NEXT_PUBLIC_CLERK_SIGN_UP_URL: Schema.String,
	NEXT_PUBLIC_DEFAULT_COLOR_SCHEME: Schema.Literals(['dark', 'light']).pipe(
		Schema.withDecodingDefaultType(Effect.succeed('dark' as const)),
	),
	NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: Schema.String.pipe(Schema.withDecodingDefaultType(Effect.succeed('G-T1DJ99VFKH'))),
	NEXT_PUBLIC_GOOGLE_ANALYTICS_LOGIN_ID: Schema.String.pipe(
		Schema.withDecodingDefaultType(Effect.succeed('G-ZDR4VV5YSX')),
	),
	NEXT_PUBLIC_JWT_AUDIENCE_CLOUDPRINT: Schema.Literal('https://cloudprint.frachter.app').pipe(
		Schema.withDecodingDefaultType(Effect.succeed('https://cloudprint.frachter.app' as const)),
	),
	NEXT_PUBLIC_ORG_ID_FRACHTER: Schema.String.pipe(Schema.withDecodingDefaultType(Effect.succeed('org_e3f4ec1f7d3'))),
	NEXT_PUBLIC_ORIGIN_RUN: Schema.String,
	NEXT_PUBLIC_ORIGIN_WWW: Schema.String,
});

const decode = Schema.decodeUnknownResult(envSchema, { errors: 'all' });
const result = decode(process.env.NEXT_PHASE === 'phase-production-build' ? DEFAULTS : envVars);

if (Result.isFailure(result)) {
	const message = String(result.failure);
	console.error(message);
	throw new Error(message);
}

export const env = Object.freeze(result.success);

// HINT: do not use destructuring as envalid sets non-enumarable properties
// export const env = parseEnv(process.env.NEXT_PHASE === 'phase-production-build' ? DEFAULTS : envVars, envSchema);
